const distributionPriceTypes = {
	SINGLE: "single",
	PAY_PER_LOAN: "pay_per_loan",
};

export default distributionPriceTypes;
